import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { GeneralSettingsSetup } from "../../components/GeneralSettingsSetup";

export const GeneralSettingsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="General Settings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "General Settings", navigateTo: "/settings/general/list" },
        // { text: "Create General Settings", navigateTo: "/settings/general/setup" }
      ]}
      mainContents={<GeneralSettingsSetup />}
    />
  );
};
